import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Animate entrance
    requestAnimationFrame(() => {
      this.element.classList.add("daily-reward--open")
    })
  }

  close() {
    this.element.classList.remove("daily-reward--open")
    this.element.classList.add("daily-reward--closing")
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
